import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forbid',
  templateUrl: './forbid.component.html',
  styleUrls: ['./forbid.component.scss']
})
export class ForbidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
